module.exports = __webpack_public_path__ + "static/media/JustFleckless–403Bambus.f5f717cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fabrics/JustFleckless–403Bambus.jpg
// module id = 35
// module chunks = 0